import { useRouter } from 'next/router'
import { useMemo } from 'react'

const BASE_URL = 'https://www.gazin.com.br'

export const useCanonicalUrl = () => {
  const router = useRouter()

  const canonicalUrl = useMemo(() => {
    const path = router.asPath.split('?')[0]
    const page = Number(router.query?.pagina)
    const params = new URLSearchParams()

    if (!!page && page > 1) {
      params.set('pagina', page.toString())
    }

    const url = new URL(BASE_URL)
    url.pathname = path
    url.search = params.toString()

    return url
  }, [router.asPath, router.query?.pagina])

  return { canonicalUrl }
}
